module.exports = __webpack_public_path__ + "static/media/nova_logo.264568bb.png";